import React, { memo } from 'react';

import { Icon } from '@mdi/react';
import cx from 'clsx';

import { Image } from 'components';
import { mdiAccount, mdiVolumeMute } from '@mdi/js';
import Timer, { TimerProps } from './timer';
import { usePersonHighlight } from '../../../usePersonHighlight';
import styles from './style.module.scss';

export type ItemProps = {
  icon?: string;
  image?: string;
  name: string;
  /** Asset / user id: hovering lights up the same person in the other lists. */
  personId?: string;
  label?: string;
  /** The operator looking at the screen: never shows a photo; `label` ("You") is badged next to the name. */
  self?: boolean;
  timer?: TimerProps;
  muted: boolean;
  toggleMuted: () => void;
};

const initials = (name: string) => name
  .split(/\s+/)
  .filter(Boolean)
  .slice(0, 2)
  .map((part) => part[0]?.toUpperCase() ?? '')
  .join('');

/** Same card as the people in the helpers list. */
const Item = memo<ItemProps>(({
  icon, image, name, personId, label, self, timer, muted,
}) => {

  const { highlighted, hoverProps } = usePersonHighlight(personId);

  const avatarImage = self ? undefined : image;
  const avatarIcon = self ? mdiAccount : icon;
  const letters = !avatarImage && !avatarIcon ? initials(name) : '';

  return (
    <div className={cx(styles.card, self && styles.self, highlighted && styles.highlighted)} {...hoverProps}>
      <div className={styles.avatarWrap}>
        <div className={styles.avatar}>
          {avatarImage && <Image src={avatarImage} alt="" className={styles.image}/>}
          {!avatarImage && avatarIcon && <Icon path={avatarIcon} size="22px"/>}
          {letters}
          {!avatarImage && !avatarIcon && !letters && <Icon path={mdiAccount} size="22px"/>}
        </div>
        {muted && (
          <span className={styles.muted}><Icon path={mdiVolumeMute} size="12px"/></span>
        )}
        {timer && (
          <span className={styles.timer}><Timer {...timer}/></span>
        )}
      </div>
      <div className={styles.text}>
        <span className={styles.name} title={name}>{name}</span>
        {label && <span className={cx(styles.label, self && styles.selfLabel)}>{label}</span>}
      </div>
    </div>
  );

});

export default Item;
